import * as THREE from 'three';
import { RenderQuality, getQualitySettings } from './RenderQuality';

/**
 * Configures shadow parameters for the primary directional (sun) light. Shadow-distance limits and
 * map size are driven by the active {@link RenderQuality} preset (spec §17).
 */
export class ShadowManager {
  configure(sun: THREE.DirectionalLight, quality: RenderQuality): void {
    const settings = getQualitySettings(quality);
    sun.castShadow = settings.shadows;
    if (!settings.shadows) return;

    sun.shadow.mapSize.set(settings.shadowMapSize, settings.shadowMapSize);
    sun.shadow.bias = -0.0004;
    sun.shadow.normalBias = 0.02;

    const cam = sun.shadow.camera;
    const half = settings.shadowDistance;
    cam.left = -half;
    cam.right = half;
    cam.top = half;
    cam.bottom = -half;
    cam.near = 0.5;
    cam.far = settings.shadowDistance * 3;
    cam.updateProjectionMatrix();
  }
}
